import { CloseButton } from '@chakra-ui/react'

export default CloseButton
